import { Component } from '@angular/core';
import { ModalController, Loading, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { isSameMonth, isSameDay } from 'date-fns';
import { CalendarEvent, CalendarDateFormatter } from 'angular-calendar';
import { SessionAddPage } from './../../pages/session-add/session-add';
import { SessionDetailPage } from './../../pages/session-detail/session-detail';
import { SessionUpdatePage } from './../../pages/session-update/session-update';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Subject } from 'rxjs/Subject';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { CustomDateFormatterProvider } from '../../providers/custom-date-formatter/custom-date-formatter';
import moment from 'moment';

interface myInterface {
  dob: number;
  calendar: [{
    complete: boolean;
    date: Date;
    fileReq: boolean;
    files: [{
      fullPath: string;
      name: string;
      path: string;
    }];
    notes: string;
    task: boolean;
    topic: string;
  }];
  company: string;
  name: string;
  ocupation: string;
  sex: string;
}

interface myInterface2 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  title: string;
  sessionDate: Date;
  tasks: string[];
  alumno: any;
}

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  },
  royal: {
    primary: '#59d7b5',
    secondary: '#a6eedb'
  }
};

@Component({
  selector: 'calendar',
  templateUrl: 'calendar.html',
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatterProvider
    }
  ]
})

export class CalendarComponent {

  itemsCollection: AngularFirestoreCollection<myInterface>;
  items: myInterface[];
  sessionsCollection: AngularFirestoreCollection<myInterface>;
  sessions: myInterface2[];
  refresh: Subject<any> = new Subject();
  locale: string = 'es';
  activeDayIsOpen: boolean = true;
  view: string = 'month';
  viewDate: Date = new Date();
  currentUser: any;
  loading: Loading;
  events: CalendarEvent[] = [];

  calSet = {
    end: 24,
    start: 0,
    segments: 1,
    segmentHeight: 45
  };

  exclude = [0, 6];
  calendar: any[];

  constructor(public asf: AngularFirestore, public modalCtrl: ModalController, public afAuth: AngularFireAuth, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    registerLocaleData(localeEs, 'es');

    afAuth.auth.onAuthStateChanged(user => {
      this.itemsCollection = asf.collection("Users", ref => ref.where("coach", "==", user.uid).where("type", "==", 2).orderBy('uppercaseName','asc'));
      this.itemsCollection.snapshotChanges().subscribe((data) => {
        this.items = data.map((item) => {
          const data = item.payload.doc.data() as myInterface;
          const id = item.payload.doc.id;
          return { id, ...data }
        });
      });
    });


    let sub = afAuth.authState.subscribe(data => {
      if (data && data.uid) {
        this.viewAllSession();
      }
      sub.unsubscribe();
    });
  }

  selectUser(item: any) {
    if (item && item.id) {
      this.currentUser = item;
      this.sessionsCollection = this.asf.collection("Sessions", ref => ref.where("idAlumno", "==", this.currentUser.id).where("idCoach", "==", this.afAuth.auth.currentUser.uid).orderBy("sessionDate", "desc"));
      this.sessionsCollection.snapshotChanges().subscribe((data) => {
        this.events = [];
        this.sessions = data.map((item, index) => {
          this.events.push({
            start: new Date(item.payload.doc.data().sessionDate),
            title: item.payload.doc.data().title,
            color: colors.royal
          });
          const data = item.payload.doc.data() as myInterface2;
          data.alumno = this.asf.doc("Users/" + data.idAlumno).ref.get().then(data => {
            return data.get('name');
          });
          const id = item.payload.doc.id;
          this.events[index]["datos"] = { id, ...data };
          return { id, ...data }
        });
      });
    }
  }

  handleEvent(item: any): void {
    if (item && item.event && item.event.datos) {
      let Modal = this.modalCtrl.create(SessionDetailPage, { "item": item.event.datos });
      Modal.present();
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }

  presentAddModal() {
    if (this.currentUser && this.currentUser.id) {
      let addModal = this.modalCtrl.create(SessionAddPage, { "idParent": this.currentUser.id, "nameParent": this.currentUser.name, "coachId": this.currentUser.coach });
      addModal.present();
    }
  }

  clickedDate(x) {
    this.viewDate = x;
  }

  presentSessionModal(x) {
    let profileModal = this.modalCtrl.create(SessionDetailPage, { item: x });
    profileModal.present();
  }

  deleteItem(id: string) {
    this.presentLoadingCustom();
    this.asf.collection("Sessions").doc(id).delete().then(() => {
      this.loading.dismiss();
      this.presentToast('Eliminado correctamente');
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast('Ha ocurrido un error');
    });
  }

  updateItem(item: any) {
    let Modal = this.modalCtrl.create(SessionUpdatePage, { "item": item });
    Modal.present();
  }

  presentConfirmDelete(id: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar sesión',
      message: '¿Estas seguro de eliminar sesión?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id);
          }
        }
      ]
    });
    alert.present();
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  viewAllSession() {
    this.currentUser = null;
    this.sessionsCollection = this.asf.collection("Sessions", ref => ref.where("idCoach", "==", this.afAuth.auth.currentUser.uid).orderBy("sessionDate", "desc"));
    this.sessionsCollection.snapshotChanges().subscribe((data) => {
      this.events = [];
      this.sessions = data.map((item, index) => {
        this.events.push({
          start: new Date(item.payload.doc.data().sessionDate),
          title: item.payload.doc.data().title,
          color: colors.royal
        });
        const data = item.payload.doc.data() as myInterface2;
        data.alumno = this.asf.doc("Users/" + data.idAlumno).ref.get().then(data => {
          return data.get('name');
        });
        const id = item.payload.doc.id;
        this.events[index]["datos"] = { id, ...data };
        return { id, ...data }
      });
    });
  }

  viewItem(item: any) {
    let Modal = this.modalCtrl.create(SessionDetailPage, { "item": item });
    Modal.present();
  }

  stringDate(date: any): string {
    moment.locale("es");
    return moment(date).format("lll");
  }

}



// WEBPACK FOOTER //
// ./src/components/calendar/calendar.ts